import React from 'react'

import { GreyLighten47 } from '../../const/colors'
import { IIcons } from './types'

export default (props: IIcons) => {
  const { style, fill = GreyLighten47 } = props
  const defaultStyle = { width: 18, height: 18 }

  return (
    <svg style={{ ...defaultStyle, ...style }} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_4574_445489)">
        <path
          d="M8.99997 4.2V13.8M11.4 7C11.4 5.896 10.3256 5 8.99997 5C7.67438 5 6.59998 5.896 6.59998 7C6.59998 8.10399 7.67438 8.99999 8.99997 8.99999C10.3256 8.99999 11.4 9.89599 11.4 11C11.4 12.104 10.3256 13 8.99997 13C7.67438 13 6.59998 12.104 6.59998 11M16.75 9C16.75 13.2802 13.2802 16.75 9 16.75C4.71979 16.75 1.25 13.2802 1.25 9C1.25 4.71979 4.71979 1.25 9 1.25C13.2802 1.25 16.75 4.71979 16.75 9Z"
          stroke={fill}
          strokeWidth="1.2"
          strokeLinecap="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_4574_445489">
          <rect width="18" height="18" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
